define([], ()=> {
    return (question)=> {
        const choices = question.choices.map((choice)=> {
            return {
                'code': choice.choiceCode,
                'name': choice.displayKey
            };
        });

        return {
            'availableValues': {
                value: choices
            }
        };
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/questionsets/aspects/AvailableValues.js
 **/